import { Monitor } from "../../../../types/assessment/monitor.ts";
import { DEFAULT_COMPUTE_SUFFIX } from "../../gcp-asset.ts";

export const GcpResourcePresets = {
  "GCP Compute Instance with Default Service Account": Monitor({
    show: "resource",
    scopes: ["gcloud"],
    searchTerm: `lateral:identity:${DEFAULT_COMPUTE_SUFFIX} resource:type:"instance"`,
    label: "GCP compute instance with default service account",
    priority: "MEDIUM",
    cta: "The service account attached to this compute instance is the default compute service account. Consider replacing with a non-default service account.",
    description:
      "GCP compute instances with the default compute service account attached.",
  }),
};
